import { render, staticRenderFns } from "./footerViewTerms.vue?vue&type=template&id=5518e969&scoped=true"
import script from "./footerViewTerms.vue?vue&type=script&lang=js"
export * from "./footerViewTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5518e969",
  null
  
)

export default component.exports